// extracted by mini-css-extract-plugin
export default {"banner":"banner_banner__01aso","banner__title":"banner_banner__title__eSFX-","banner__subtitle":"banner_banner__subtitle__G-6BI"};